<template>
  <div class="store-card">
    <div class="header">
      <skeleton-loader-vue
        type="rect"
        :width="360"
        :height="300"
        animation="fade"
      />
    </div>
    <div class="body">
      <p>
        <skeleton-loader-vue
          type="rect"
          :width="220"
          :height="15"
          :rounded="true"
          animation="fade"
        />
      </p>
      <p>
        <skeleton-loader-vue
          type="rect"
          :width="200"
          :height="15"
          :rounded="true"
          animation="fade"
        />
      </p>
      <div class="card-content">
        <div class="row">
          <div class="col-6">
            <span>
              <skeleton-loader-vue
                type="rect"
                :width="100"
                :height="15"
                :rounded="true"
                animation="fade"
              />
            </span>
          </div>
          <div class="col-6">
            <span class="value">
              <skeleton-loader-vue
                type="rect"
                :width="120"
                :height="15"
                :rounded="true"
                animation="fade"
              />
            </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-6">
            <span>
              <skeleton-loader-vue
                type="rect"
                :width="80"
                :height="15"
                :rounded="true"
                animation="fade"
              />
            </span>
          </div>
          <div class="col-6">
            <span class="value">
              <skeleton-loader-vue
                type="rect"
                :width="90"
                :height="15"
                :rounded="true"
                animation="fade"
              />
            </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-6">
            <span>
              <skeleton-loader-vue
                type="rect"
                :width="90"
                :height="15"
                :rounded="true"
                animation="fade"
              />
            </span>
          </div>
          <div class="col-6">
            <span class="value">
              <skeleton-loader-vue
                type="rect"
                :width="70"
                :height="15"
                :rounded="true"
                animation="fade"
              />
            </span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-6">
            <span>
              <skeleton-loader-vue
                type="rect"
                :width="80"
                :height="15"
                :rounded="true"
                animation="fade"
              />
            </span>
          </div>
          <div class="col-6">
            <span class="value">
              <skeleton-loader-vue
                type="rect"
                :width="90"
                :height="15"
                :rounded="true"
                animation="fade"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSkeletonLoader from "skeleton-loader-vue";

export default {
  name: "skeleton-card",
  props: {
    data: {
      type: Object,
    },
  },
  components: {
    "skeleton-loader-vue": VueSkeletonLoader,
  },
  mounted() {},
};
</script>

<style></style>
